import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_PURPLE,
    fontSize: 18,
    textAlign: 'center',
  },
  mainContentBox: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 6,
    boxShadow: '0px 3px 6px #00000029',
  },
  list: {
    listStyleType: 'none',
    paddingLeft: theme.spacing(0.5),

    '& li': {
      fontSize: 16,
      fontWeight: 'bold',
      padding: theme.spacing(1, 1),
    },
  },
}));
